/* eslint-disable no-unused-expressions */
import React, {useState, useEffect} from 'react';

import './index.scss';
import {ADMIN_ROLE, ERROR_TYPES} from '../../constants/global';
import {ValidationTable} from './modalTable';

function validationModal({modalId, modalData, role, submitAnywayAction, cancelAction}) {
  const [compwarnarray, updateCompWarnArray] = useState([]);
  useEffect(() => {
    if(modalData.length > 0) {
      const temp = [];
      modalData.forEach(({validation_type}) => temp.push(validation_type));
      updateCompWarnArray([...temp]);
    }
  }, [modalData]);
  return(
    <div className='cb-modal' id={`${modalId}`} aria-hidden='true'
      data-cb-apricot='modal'>
      <div className='cb-modal-overlay' tabIndex='-1'>
        <div style={{width: '100%'}} className='cb-modal-container submitModal_container' role='dialog' aria-modal='true' aria-labelledby='submitModalTitleValidate' aria-describedby='submitDlgDscValidate'>
          <div className='cb-modal-header'>
            <h2 className='cb-modal-title submitModal_container-title' id='submitModalTitleValidate'>
              <i className='cb-icon cb-icon-circular cb-exclamation cb-red1-color' aria-hidden='true' />
              <span style={{marginLeft: '20px'}}>We were unable to submit your category.</span>
            </h2>

            {/* <!-- close button --> */}
            <button type='button' className='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close' aria-describedby='submitModalTitleValidate'
                    onClick={cancelAction} data-cb-modal-close>
              <span className='cb-icon cb-x-mark' aria-hidden='true' />
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='cb-modal-content submitModal_container-content' id='submitDlgDscValidate'>
            <p>Please fix all errors and resubmit your category.</p>
            <div style={{margin: '10px 0px'}}>
              <ValidationTable modalData={modalData} role={role} />
            </div>
          </div>
          <div className='cb-modal-footer'>
            <div className='cb-btn-row subBtnRow' id='validateSubBtnRow'>
              {
                role !== ADMIN_ROLE ?(compwarnarray.every(el => el===ERROR_TYPES.COMPLEX)?<button type='button' className='cb-btn cb-btn-naked' data-cb-modal-close aria-label='Submit Anyway' onClick={() => {submitAnywayAction();cancelAction();}}>Submit anyways</button>:<button type='button' className='cb-btn cb-btn-naked' data-cb-modal-close aria-label='Close' onClick={cancelAction}>Close</button>):(compwarnarray.every(el => el===ERROR_TYPES.COMPLEX)?null:<button type='button' className='cb-btn cb-btn-naked' data-cb-modal-close aria-label='Close' onClick={cancelAction}>Close</button>)
              }
              {/* <!-- close button --> */}
              <button type='button' onClick={cancelAction} className='cb-btn cb-btn-primary' data-cb-modal-close aria-label='Edit Now'>Edit Now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default validationModal;